/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
 const { RequestCommand } = require('./RequestCommands');
 const { updateGraphItemsPosition } = require('../utils/shapes');
 

export default class UpdateGraphItemsCommand extends RequestCommand {
	constructor(graph) {
		super(graph);
		this.graph = graph;
		this.isVolatile = true;
	}

	getExecuteRequest() {
		const { streamsheetIds, graphItems } = updateGraphItemsPosition(this.graph);
		return this.createRequest({ streamsheetIds, graphItems });
	}
	getRedoRequest() {}
	getUndoRequest() {}
	handleResult() {}
}
